module.exports = __webpack_public_path__ + "static/teen-health-92cdedfaf46cde34c70c4161ec832a34.png";